import React from 'react';
import {connect} from 'react-redux';
import Stripecheckout from 'react-stripe-checkout';

import mapDispatch from '~/misc/mapDispatch';
import Button from '~/components/common/Button';
import store from '~/store';
import LoadingSpiner from '~/components/pages/MyAccount/share/LoadingSpiner';
import css from './index.css';
import config from '~/config';

class Stripe extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingBtn: false,
    };
    this.onOpened = this.onOpened.bind(this);
    this.onClosed = this.onClosed.bind(this);
    this.onToken = this.onToken.bind(this);
    this.clickFn = this.clickFn.bind(this);
  }
  componentWillMount() {
    if (document.getElementsByClassName('pages-PaymentProcess-btnWrap')[0]
      || document.getElementsByName('stripe_checkout_app')[0]
      || document.getElementById('container')
      || document.getElementsByClassName('ModalContainer')[0]
    ) {
      return null;
    }
  }

  componentDidMount() {
    // 自动打开支付弹窗
    if ((this.props.from === 'a') && !this.refs.StripeForm.open) {
      // this.refs.StripeForm.onClick();
    }
  }

  render() {
    const panelLabel = this.props.amount ? '' : this.props.btnText;
    const amount = Number(this.props.amount) || 0;
    const email = this.props.email;
    return (
      <Stripecheckout
        name='Trucker Path Inc.'
        image='https://truckloads.truckerpath.com/assets/favicon2.ico'
        locale='en'
        panelLabel={panelLabel}
        zipCode={false}
        amount={amount}
        stripeKey={config.stripeKey}
        token={this.onToken}
        opened={this.onOpened}
        closed={this.onClosed}
        onClick={this.clickFn}
        email={email}
        triggerEvent='onClick'
        ref='StripeForm'
      >
        <Button className={css.wide} mods={['large', 'action']}>
          {(this.state.loadingBtn || this.props.btnText === 'loading')
            ? <LoadingSpiner/>
            : this.props.btnText
          }
        </Button>
      </Stripecheckout>
    );
  }

  clickFn(e) {
    e.preventDefault();
    if (this.state.loadingBtn) {
      return null;
    }
    return this.setState({
      loadingBtn: true,
    });
  }

  onOpened() {
    if (this.state.loadingBtn) {
      return null;
    }
    return this.setState({
      loadingBtn: true,
    });
  }

  onClosed() {
    return this.setState({
      loadingBtn: false,
    });
  }

  onToken(token) {
    const userID = this.props.user.id;
    const actionFn = this.props.actionFn;
    let obj = {
      account_id: userID,
      token: token.id,
    };

    if (this.props.query) {
      obj = Object.assign(obj, this.props.query);
    }

    return store.dispatch((dispatch, getState) => actionFn(dispatch, getState, obj));
  }
}

export default connect(
  ({user}) => ({user}),
  mapDispatch({}))(Stripe);



// WEBPACK FOOTER //
// ./src/components/pages/Stripe/index.js